import axios from "axios";
import {toast} from "react-toastify";
import {queryClient} from "./query-client.js";
import {SESSION_QUERY_KEY} from "./session.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const BASE_URL = import.meta.env.BASE_URL;

const SESSION_ENDED = "Sessão encerrada";
const SESSION_ELSEWHERE = "Usuário logado em outra estação";
const FORBIDDEN = "Acesso negado.";

const LICENSE_MESSAGES = {
    "license.expired": "Licença expirada.",
    "license.ibge.not.matching": "IBGE da entidade não corresponde ao da licença.",
    "not.loaded.license": "Servidor indisponível.",
    "entity.without.ibge": "IBGE não encontrado.",
    "no.entity": "Sem entidade.",
    "no.admin": "Sem administrador.",
    "keeper.not.found": "Servidor indisponível.",
};

let redirecting = false;

const isAuthEndpoint = (url = "") =>
    (API_KEEPER && url.startsWith(API_KEEPER)) ||
    url.includes("/api/validate-token") ||
    url.includes("/get/login/info");

const isOnLoginPage = () =>
    window.location.pathname.replace(/\/$/, "") === BASE_URL.replace(/\/$/, "");

const isOnInstaller = () => window.location.pathname.includes("/installer");

const redirectToInstaller = () => {
    queryClient.removeQueries({queryKey: SESSION_QUERY_KEY});

    if (redirecting || isOnInstaller()) return;

    redirecting = true;
    window.location.assign(`${BASE_URL}installer`.replace(/([^:]\/)\/+/g, "$1"));
};

export const redirectToLogin = (message) => {
    queryClient.removeQueries({queryKey: SESSION_QUERY_KEY});

    if (redirecting || isOnLoginPage()) return;

    redirecting = true;
    const query = message ? `?error_message=${encodeURIComponent(message)}` : "";
    window.location.assign(`${BASE_URL}${query}`.replace(/([^:]\/)\/+/g, "$1"));
};

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const {response, config} = error;
        if (!response) return Promise.reject(error);

        const code = response.data?.code;
        const license = response.data?.license;

        if (response.status === 503 && code === "installer" && (license === "keeper.not.found" || license === "not.loaded.license")) {
            const message = LICENSE_MESSAGES[response.data?.license];
            toast.error(message, {toastId: "installer"});
            redirectToLogin();
            return Promise.reject(error);
        }

        if (response.status === 503 && code === "installer") {
            redirectToInstaller();
            return Promise.reject(error);
        }

        if (response.status === 503 && code === "license") {
            const message = LICENSE_MESSAGES[response.data?.license] ?? "Licença inválida.";
            toast.error(message, {toastId: "license"});
            return Promise.reject(error);
        }

        if (response.status === 503) {
            redirectToLogin();
            return Promise.reject(error);
        }

        if (isAuthEndpoint(config?.url)) return Promise.reject(error);

        if (response.status === 401 && code === "session_ended") {
            redirectToLogin(SESSION_ENDED);
        } else if (response.status === 403 && code === "session_elsewhere") {
            redirectToLogin(SESSION_ELSEWHERE);
        } else if (response.status === 403) {
            toast.error(FORBIDDEN, {toastId: "forbidden"});
        }

        return Promise.reject(error);
    }
);
